import React from 'react'
import { Link, Flex, Icon } from '@chakra-ui/react'
import { Link as RouterLink } from 'react-router-dom'

function DrawerItem({ icon, children, show, ...rest }) {
  if (typeof show === 'boolean' && !show) return null
  const isLocalLink = !!rest.to
  return (
    <Link
      as={isLocalLink ? RouterLink : null}
      target={!isLocalLink ? '_blank' : null}
      style={{ textDecoration: 'none' }}
      w="full"
      {...rest}
    >
      <Flex align="center" px="6" py="2" role="group" cursor="pointer">
        {icon && <Icon mr="4" fontSize="16" as={icon} />}
        {children}
      </Flex>
    </Link>
  )
}

export default DrawerItem
